export default {
  computed: {
    isCarPassportIncorrect() {
      if (this.userData.role === 'lender' || !this.extra_user_info.car_owner) {
        return false;
      }

      return this.car_passport_files.length < 2;
    },
    isRealEstateDocumentsIncorrect() {
      if (this.userData.role === 'lender' || !this.extra_user_info.real_estate_owner) {
        return false;
      }

      return this.real_estate_files.length < 1;
    },
    isExtraDataIncorrect() {
      return this.userData.role === 'lender'
        ? false
        : !this.extra_user_info.total_income
          || !this.extra_user_info.dependens_number
          || this.isCarPassportIncorrect
          || this.isRealEstateDocumentsIncorrect;
    },
  },
};